import React, { useState, useEffect, useRef } from "react";
import ReportViewerRenderer from "./ReportViewerRenderer";
import MultimediaService from "services/MultimediaService";
import LoadingLocal from "plugins/TS-lib-utils-public/components/Loading/LoadingLocal";
import { Pagination, Row, PaginationItem, PaginationLink } from "reactstrap";

const ReportViewer = ({ study, activeTab }) => {

    const mounted = useRef(false);
    const [file, setFile] = useState(null);
    const [loading, isLoading] = useState(false);

    const [numPages, setNumPages] = useState();
    const [pageHeight, setPageHeight] = useState(0);
    const [pageNumber, setPageNumber] = useState(1);
    const [loadingPDF, setLoadingPDF] = useState(false);

    // Function will execute on click of button
    function base64ToArrayBuffer(base64) {
        var binaryString = window.atob(base64);
        var binaryLen = binaryString.length;
        var bytes = new Uint8Array(binaryLen);
        for (var i = 0; i < binaryLen; i++) {
            var ascii = binaryString.charCodeAt(i);
            bytes[i] = ascii;
        }
        //return new memory address for the bytes
        return [...bytes];
    }

    useEffect(() => {
        if (study.reportFile.length <= 25) {
            isLoading(true);
            MultimediaService.getReportFile(study.reportFile).then((res) => {
                if (mounted.current && !file && activeTab === "3" && res) {
                    isLoading(false);
                    setFile(base64ToArrayBuffer(res.data));
                }
            });
        }
        mounted.current = true;
    }, []);

    useEffect(() => {
        if (mounted.current && !file && activeTab === "3" && study.reportFile.length > 25) {
            setFile(base64ToArrayBuffer(study.reportFile));
        }
    }, [mounted.current, activeTab]);

    if (!study || !Object.keys(study).length) {
        return <></>;
    }

    return (

        <>
            {/* react-pdf performs === comparisons so React.memo is required ONLY for the props it needs.
                Otherwise, it will refresh all the props and the render will fail           
            */}
            {loading ? <LoadingLocal /> : (
                <>
                    <Row className="text-center justify-content-center mt-3">
                        <nav aria-label="Page navigation example">
                            <Pagination
                                className="pagination justify-content-end"
                                listclassname="justify-content-end"
                            >
                                <PaginationItem disabled={pageNumber === 1 || loadingPDF}>
                                    <PaginationLink
                                        href="#previous-page"
                                        onClick={e => {
                                            e.preventDefault()
                                            setPageNumber(pageNumber - 1);
                                        }}
                                        tabIndex="-1"
                                        className="bg-info text-white"
                                    >
                                        <i className='fa fa-angle-double-left'></i>
                                    </PaginationLink>
                                </PaginationItem>

                                <PaginationItem disabled={pageNumber < 3 || loadingPDF}>
                                    <PaginationLink href="#minus-two" onClick={e => {
                                        e.preventDefault();
                                        setPageNumber(pageNumber - 2);
                                    }}>
                                        {pageNumber > 2 ? pageNumber - 2 : " "}
                                    </PaginationLink>
                                </PaginationItem>

                                <PaginationItem disabled={pageNumber <= 1 || loadingPDF}>
                                    <PaginationLink href="#minus-one"
                                        onClick={e => {
                                            e.preventDefault();
                                            setPageNumber(pageNumber - 1);
                                        }}>
                                        {pageNumber >= 2 ? pageNumber - 1 : " " }
                                    </PaginationLink>
                                </PaginationItem>

                                <PaginationItem active>
                                    <PaginationLink href="#actual-page" onClick={e => { e.preventDefault() }} className="bg-info">
                                        {pageNumber}
                                    </PaginationLink>
                                </PaginationItem>

                                <PaginationItem disabled={pageNumber === numPages || loadingPDF}>
                                    <PaginationLink href="#plus-one" onClick={e => {
                                        e.preventDefault();
                                        setPageNumber(pageNumber + 1);
                                    }}>
                                        {pageNumber < numPages ? pageNumber + 1 : " "}
                                    </PaginationLink>
                                </PaginationItem>

                                <PaginationItem disabled={!((numPages - pageNumber) >= 2) || loadingPDF}>
                                    <PaginationLink href="#plus-two" onClick={e => {
                                        e.preventDefault();
                                        setPageNumber(pageNumber + 2);
                                    }}>
                                        {(numPages - pageNumber) >= 2 ? pageNumber + 2 : " "}
                                    </PaginationLink>
                                </PaginationItem>

                                <PaginationItem disabled={!(pageNumber < numPages) || loadingPDF}>
                                    <PaginationLink href="#next-page" onClick={e => {
                                        e.preventDefault();
                                        setPageNumber(pageNumber + 1);
                                    }}
                                        className="bg-info text-white"
                                    >
                                        <i className='fa fa-angle-double-right'></i>
                                    </PaginationLink>
                                </PaginationItem>

                            </Pagination>
                        </nav>
                    </Row>

                    {file && 
                        <ReportViewerRenderer 
                            file={file}
                            setNumPages={setNumPages}
                            pageHeight={pageHeight}
                            setPageHeight={setPageHeight}
                            pageNumber={pageNumber}
                            setLoadingPDF={setLoadingPDF}
                        />
                    }
                
                    <Row className="text-center justify-content-center mt-3">
                        <nav aria-label="Page navigation example">
                            <Pagination
                                className="pagination justify-content-end"
                                listclassname="justify-content-end"
                            >
                                <PaginationItem disabled={pageNumber === 1 || loadingPDF}>
                                    <PaginationLink
                                        href="#previous-page"
                                        onClick={e => {
                                            e.preventDefault()
                                            setPageNumber(pageNumber - 1);
                                        }}
                                        tabIndex="-1"
                                        className="bg-info text-white"
                                    >
                                        <i className='fa fa-angle-double-left'></i>
                                    </PaginationLink>
                                </PaginationItem>

                                <PaginationItem disabled={pageNumber < 3 || loadingPDF}>
                                    <PaginationLink href="#minus-two" onClick={e => {
                                        e.preventDefault();
                                        setPageNumber(pageNumber - 2);
                                    }}>
                                        {pageNumber > 2 ? pageNumber - 2 : " "}
                                    </PaginationLink>
                                </PaginationItem>

                                <PaginationItem disabled={pageNumber <= 1 || loadingPDF}>
                                    <PaginationLink href="#minus-one"
                                        onClick={e => {
                                            e.preventDefault();
                                            setPageNumber(pageNumber - 1);
                                        }}>
                                        {pageNumber >= 2 ? pageNumber - 1 : " " }
                                    </PaginationLink>
                                </PaginationItem>

                                <PaginationItem active>
                                    <PaginationLink href="#actual-page" onClick={e => { e.preventDefault() }} className="bg-info">
                                        {pageNumber}
                                    </PaginationLink>
                                </PaginationItem>

                                <PaginationItem disabled={pageNumber === numPages || loadingPDF}>
                                    <PaginationLink href="#plus-one" onClick={e => {
                                        e.preventDefault();
                                        setPageNumber(pageNumber + 1);
                                    }}>
                                        {pageNumber < numPages ? pageNumber + 1 : " "}
                                    </PaginationLink>
                                </PaginationItem>

                                <PaginationItem disabled={!((numPages - pageNumber) >= 2) || loadingPDF}>
                                    <PaginationLink href="#plus-two" onClick={e => {
                                        e.preventDefault();
                                        setPageNumber(pageNumber + 2);
                                    }}>
                                        {(numPages - pageNumber) >= 2 ? pageNumber + 2 : " "}
                                    </PaginationLink>
                                </PaginationItem>

                                <PaginationItem disabled={!(pageNumber < numPages) || loadingPDF}>
                                    <PaginationLink href="#next-page" onClick={e => {
                                        e.preventDefault();
                                        setPageNumber(pageNumber + 1);
                                    }}
                                        className="bg-info text-white"
                                    >
                                        <i className='fa fa-angle-double-right'></i>
                                    </PaginationLink>
                                </PaginationItem>

                            </Pagination>
                        </nav>
                    </Row>
                
                </>
            )}
            
        </>
    )
}

export default React.memo(ReportViewer);